import React from 'react'
import PropTypes from 'prop-types'
import { Title, Grid, GridItem, ImageContainer } from './styles'
import ExpandIcon from '../../images/ic-expand.svg'

const LookbookGrid = ({ images, title, zoomHandler }) => (
  <div>
    <Title>- {title} -</Title>
    <Grid>
      {images.map((img, i) => (
        <GridItem key={i}>
          <ImageContainer onClick={() => zoomHandler(i)}>
            <img src={img.image} alt={img.altText} />
            {/* <ExpandIcon alt="click to zoom in image" /> */}
          </ImageContainer>
          <p>{img.description}</p>
        </GridItem>
      ))}
    </Grid>
  </div>
)

LookbookGrid.propTypes = {}

export default LookbookGrid
